import { View } from '@/styles/reactnative';
import { ThemeContext } from '@/theme/ThemeProvider';
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import useTradeStore from '../../../../hooks/trade/tradeStore';
import DerivativesBody from './DerivativesBody';
import DerivativesHeader from './DerivativesHeader';
import DerivativesNavBarTabs from './DerivativesNavBarTabs';
import { DerivativesTransactionWrapper } from './styles';
import { useTranslation } from 'react-i18next';
import { useExchangeStore } from '@app/hooks/trade/exchangeStore.tsx';

const DerivativesTransaction = () => {
  const { data: tradeStore, mutate: mutateTradeStore } = useTradeStore();
  const { EPs } = useExchangeStore();
  const { theme, toggleTheme } = useContext(ThemeContext);
  const themeColors = useContext(ThemeContext).theme.COLORS;
  const t = useTranslation().t;

  const [tab, setTabState] = useState('L');

  // useEffect(() => {
  //   const id = Number(location.pathname.split("/")[2]);
  //   if (!isNaN(id)) {
  //     setEpIdFromUrl(id);
  //   }
  // }, [location.pathname]);

  useEffect(() => {
    const id = Number(location.pathname.split('/')[2]);

    if (tradeStore?.limit_market) {
      setTabState(tradeStore.limit_market);
    } else {
      const selected = EPs?.find((ep) => ep.id === id);
      if (selected) {
        mutateTradeStore({
          ...selected,
          ep_id: id,
          limit_market: localStorage.getItem('limit_market'),
        });
      }
    }
  }, [tradeStore?.limit_market]);

  const setTab = (data) => {
    const id = Number(location.pathname.split('/')[2]);

    setTabState(data);
    localStorage.setItem('limit_market', data);

    const selected = EPs?.find((ep) => ep.id === id);
    if (selected) {
      mutateTradeStore({
        limit_market: data,
        ...selected,
        ep_id: id,
        order_amount: 0,
      });
    }
  };

  // if (!tradeStore?.limit_market) {
  //   mutateTradeStore({ ...tradeStore, limit_market: "L" });
  // }

  // useEffect(() => {
  //   if (!tradeStore?.limit_market) {
  //     mutateTradeStore({ ...tradeStore, limit_market: "L" });
  //   }
  // }, [tradeStore, mutateTradeStore]);
  //
  // const setTab = useCallback((data) => {
  //   mutateTradeStore({ ...tradeStore, limit_market: data, order_amount: 0 });
  // }, [tradeStore, mutateTradeStore]);

  return (
    <DerivativesTransactionWrapper>
      <DerivativesHeader />

      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          paddingRight: 10,
          borderBottom: `1px solid ${theme.COLORS.PrimaryBorder}`,
          marginBottom: 16,
        }}
      >
        <DerivativesNavBarTabs
          tab={tab}
          setTab={setTab}
          t={t}
          textsilver={themeColors.textsilver}
        />
      </View>

      <DerivativesBody tab={tab} />
    </DerivativesTransactionWrapper>
  );
};

export default React.memo(DerivativesTransaction);
